module.exports = __webpack_public_path__ + "media/images/icons/payment-card-599fdd983707615c2ff60576b29bfac6.svg";